import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useEmpresaService() {
  const { authenticatedFetch, authenticatedFormFetch } = useApi();

  const criarEmpresa = async (formData) => {
    const response = await authenticatedFormFetch(URLS.CREATE_EMPRESA, formData);

    return response.json();
  };

  const atualizarEmpresa = async (formData) => {
    const response = await authenticatedFormFetch(URLS.UPDATE_EMPRESA, formData);

    return response.json();
  };

  const deletarEmpresa = async (id) => {

    const response = await authenticatedFetch(URLS.DELETE_EMPRESA, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarEmpresas = async () => {

    const response = await authenticatedFetch(URLS.READ_ALL_EMPRESA);

    return response.json();
  };

  const obterEmpresaPorId = async (id) => {

    const response = await authenticatedFetch(URLS.READ_EMPRESA, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  return {
    criarEmpresa,
    atualizarEmpresa,
    deletarEmpresa,
    listarEmpresas,
    obterEmpresaPorId,
  };
}